import { Box } from "@mui/material"
import React, { useEffect, useState } from "react"
import "./Badge.css"
import LogoIcon from "./../../static/badge-rssb.png";
import BadgeContent from "./BadgeContent/BadgeContent";
import { trackPromise } from "react-promise-tracker";
import axios from "axios";
import authTokenForAPI from "../../utils/authTokenForAPI";
import { isAPISuccess } from "../../utils/commonUtils";
import { AUTHORIZATION, HOSTNAME } from "../../common/constants";
import moment from "moment";

const Badge = ({ sewadarId }) => {
    const [details, setDetails] = useState([]);
    const [snack, setSnack] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    useEffect(() => {
        trackPromise(
            axios
                .get(
                    `${HOSTNAME}/sewadars/${sewadarId}?lightAccount=true`,
                    {
                        headers: { [AUTHORIZATION]: authTokenForAPI() },
                    }
                )
                .then((res) => {
                    if (isAPISuccess(res.status)) {
                        // setDetails({...res.data, photoBadge: true}); // To show how photo badge looks
                        setDetails(res.data);
                    } else {
                        setDetails({});
                        setSnack({
                            open: true,
                            severity: "error",
                            msg: "Sewadar ID not valid, please try with a valid ID.",
                        });
                    }
                })
                .catch(() => {
                    setDetails({});
                    setSnack({
                        open: true,
                        severity: "error",
                        msg: "Sewadar ID not valid, please try with a valid ID.",
                    });
                })
        );
    }, [])

    const CalculateAge = () => {

        const dob = moment(details.birthDate, "YYYY-MM-DD");
        const now = moment();

        const age = now.diff(dob, 'years');
        return age
    }

    const ExemptedDept = (dept) => {
        const allowedDepts = ["AREA SECRETARY", "BAAL SATSANG KARTA", "BOOK READER", "C.T.", "COMMITTEE MEMBER", "PATH SEWA", "PATHI", "PRESIDENT", "SATSANG KARTA", "SECRETARY", "SATSANG READER"];
        return !!!allowedDepts.includes(dept);
    }

    const BadgeBGColor = () => {
        if (details) {
            if (CalculateAge() > 70 && ExemptedDept(details.department)) {
                return "#E7B1B7"
            } else if (details.photoBadge === true) {
                return "white"
            } else return "#CACACE"
        }
    }

    const BadgeHeaderColor = () => {
        if (details) {
            if (CalculateAge() > 70 && ExemptedDept(details.department)) {
                return "#9C303D"
            } else if (details.photoBadge === true) {
                return "#4f6673"
            } else return "#4E4E55"
        }
    }


    const BadgeDeptColor = () => {
        if (details) {
            if (CalculateAge() > 70 && ExemptedDept(details.department)) {
                return "#D4737E"
            } else if (details.photoBadge === true) {
                return "#abbac2"
            } else return "#8a8a93"
        }
    }

    return (<Box className="badge-container" bgcolor={BadgeBGColor}>
        <Box height={"13mm"} className="badge-header" bgcolor={BadgeHeaderColor}><Box><img src={LogoIcon} alt="logo" height={"48px"} /></Box>
            <Box fontSize={details.subCentre === "MUZAFFARABAD" ? '8px' : '9px'}>
                <Box textAlign={"center"}>
                    Radha Soami Satsang Beas
                </Box>
                <Box textAlign={"center"}>
                    Area Saharanpur
                </Box>
                <Box textAlign={"center"} fontWeight={900} marginTop={"3px"}>
                    {details.subCentre}{details.subCentre !== details.centre ? `(${details.centre}-C)` : '-C'}
                </Box>
            </Box>
        </Box>
        <Box height={"7mm"} className="badge-dept" bgcolor={BadgeDeptColor}>{details.department}</Box>
        <Box height={"37mm"} className="badge-info"><BadgeContent details={details} photoBadge={details.photoBadge && !(CalculateAge() > 70 && ExemptedDept(details.department)) } /> </Box>
    </Box>)
}

export default Badge;